import React from "react";
import "./BreadcrumbNav.css";

function BreadcrumbNav({ items = [] }) {
  return (
    <nav className="custom-breadcrumb-parent" aria-label="breadcrumb">
      <ol className="breadcrumb-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <React.Fragment key={index}>
              <li className={`breadcrumb-item-node ${isLast ? "active-page" : ""}`}>
                {isLast ? (
                  <span>{item.label}</span>
                ) : (
                  <a href={item.url || "#"} className="breadcrumb-link">
                    {item.label}
                  </a>
                )}
              </li>
              
              {/* Render the chevron divider automatically between links */}
              {!isLast && (
                <li className="breadcrumb-chevron-separator" aria-hidden="true">
                  &gt;
                </li>
              )}
            </React.Fragment>
          );
        })}
      </ol>
    </nav>
  );
}

export default BreadcrumbNav;